// Las tres sugerencias de la portada del Catálogo (ADR-2026-10-13-catalogo-con-el-agente):
// completan la caja sin enviar, como las de `InicioAgente`. UNA fuente: `estilosAgente.ts` las
// importa de acá para el panel del agente abierto desde esta pantalla.
import { Package, Ruler, Sofa, type LucideIcon } from 'lucide-react';

export interface SugerenciaDeCatalogo {
  key: string;
  label: string;
  prompt: string;
  Icon: LucideIcon;
}

export const SUGERENCIAS_DE_CATALOGO: SugerenciaDeCatalogo[] = [
  {
    key: 'packshot-ambientes',
    label: 'Packshot + 2 ambientes',
    prompt:
      'Quiero el catálogo de estos productos: un packshot en fondo blanco de cada uno y dos ambientes distintos, con la misma luz cálida en todo el catálogo. Mirá los productos y proponeme las tomas antes de escribir nada.',
    Icon: Package,
  },
  {
    key: 'fichas-con-medidas',
    label: 'Fichas con medidas',
    prompt:
      'Necesito una ficha de cada producto con sus medidas: una foto limpia de frente para la ficha técnica y un packshot en fondo blanco. Si a alguno le faltan las medidas, pedímelas antes de armar el plan.',
    Icon: Ruler,
  },
  {
    key: 'mismo-living',
    label: 'Mismo living para todo',
    prompt:
      'Quiero todos estos muebles fotografiados en el mismo living: luz natural de tarde, piso de madera clara y paredes blancas, para que el catálogo se vea parejo. Una foto de ambiente por producto y un detalle del material.',
    Icon: Sofa,
  },
];
